module.exports = __webpack_public_path__ + "assets/img/07-m.0157749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/07-m.jpg
// module id = CVwm
// module chunks = 0